import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse, DockGroup } from 'app/shared/types';
import { environment } from 'environment/environment';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { CONTROLLERS } from './controllers';

@Injectable({
  providedIn: 'root',
})
export class DockGroupService extends BaseApiService<
  ApiResponse<{ dockGroups: DockGroup[] }>,
  ApiResponse<{ dockGroup: DockGroup }>,
  ApiResponse<{ id: string }>
> {
  constructor(public override http: HttpClient) {
    super(http, environment.siteManagementApiBaseUrl);
  }

  public override controllerName(): string {
    return `${CONTROLLERS.dockGroups}`;
  }

  public getDockGroupsPerSite(siteId: string): Observable<ApiResponse<{ dockGroups: DockGroup[] }>> {
    return this.http.get<ApiResponse<{ dockGroups: DockGroup[] }>>(
      `${this.api}/${CONTROLLERS.sites}/${siteId}/dock-groups`
    );
  }
}
